import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { BrandProvider } from "@branding/BrandProvider";
import { App } from "./App";
import { MarketingSite } from "./marketing/MarketingSite";
import "@styles/tokens.css";
import "@styles/global.css";
import "@styles/marketing.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

// Front door vs. product. The public marketing site is served at `/`; the
// authenticated financial app lives behind sign-in under `/app`. We mount the
// app with basename="/app" so its existing absolute routes/links (e.g.
// "/dashboard", "/journal") resolve unchanged — the auth gate in <App/> and its
// server-enforced RBAC/tenant isolation are untouched. Crossing between the two
// is a hard navigation (a plain <a href="/app">), so there is exactly one auth
// path and no marketing-side credential surface.
const path = window.location.pathname;
const isApp = path === "/app" || path.startsWith("/app/");

createRoot(rootEl).render(
  <StrictMode>
    <BrandProvider>
      {isApp ? (
        <BrowserRouter basename="/app">
          <App />
        </BrowserRouter>
      ) : (
        <BrowserRouter>
          <MarketingSite />
        </BrowserRouter>
      )}
    </BrandProvider>
  </StrictMode>,
);
